/**
 * Fetches user overview from GET /api/admin/users/:userId/overview.
 * No cache (staleTime=0, gcTime=0), refetch on mount.
 */
import { useNoCacheQuery } from './useNoCacheQuery';
import {
  fetchUserOverview,
  type UserOverviewResponse,
} from '../services/userManagementService';

export function useUserOverview(userId: string | undefined) {
  return useNoCacheQuery<UserOverviewResponse['data'], Error>({
    queryKey: ['user', userId, 'overview'],
    queryFn: async () => {
      if (!userId) throw new Error('userId required');
      const res = await fetchUserOverview(userId);
      if (!res.success || !res.data)
        throw new Error('Failed to load user overview');
      return res.data;
    },
    enabled: !!userId,
  });
}
